import { Dictionary } from '@reduxjs/toolkit'
import { ICategory, ICategoryDetail } from '@shared/Types'
import { EChangeValue, ISelectCategoryChange, TCategoryDetailDTO } from '../types'

export const parseValue = (value: any[]): string[] => {
  try {
    if (Array.isArray(value)) {
      return value as string[]
    }
    return JSON.parse(value) as string[]
  } catch (error) {
    return []
  }
}

export const mapCategoryDetailDTOs = (items: ICategoryDetail[]): TCategoryDetailDTO[] => {
  return items.map<TCategoryDetailDTO>((item) => ({
    Id: item.Id,
    CategoryId: item.CategoryId,
    MediaId: item.MediaId,
    Category: item.Category
  }))
}

export const mapCategoriesToCategoryDetailDTOs = (mediaId: string, items: ICategory[]) => {
  return items.map<TCategoryDetailDTO>((item) => ({
    MediaId: mediaId,
    CategoryId: item.Id,
    Category: item
  }))
}

const categoryToDictionaryByName = (items: ICategory[]): Dictionary<ICategory> => {
  return items.reduce<Dictionary<ICategory>>((a, b) => {
    const name = b.Name
    if (name) a[name] = b
    return a
  }, {})
}

export const getCategoriesByListName = (items: ICategory[], names: string[]): ICategory[] => {
  const dCategory = categoryToDictionaryByName(items)
  return names.reduce<ICategory[]>((a, b) => {
    const item = dCategory[b]
    if (item) a.push(item)
    return a
  }, [])
}

interface IGetCategoryDictionaryByNameParams {
  mediaId: string
  categories: ICategory[]
  categoryDetails: TCategoryDetailDTO[]
}
const mergeCategoryDetailDictionaryByName = (params: IGetCategoryDictionaryByNameParams): Dictionary<TCategoryDetailDTO> => {
  const { mediaId, categories, categoryDetails } = params

  const cDatails = categoryDetails.reduce<Dictionary<TCategoryDetailDTO>>((a, b) => {
    const name = b.Category?.Name
    if (name) a[name] = b
    return a
  }, {})

  return categories.reduce<Dictionary<TCategoryDetailDTO>>((a, b) => {
    const itemExist = cDatails[b.Name]
    if (itemExist) a[b.Name] = itemExist
    else a[b.Name] = { CategoryId: b.Id, MediaId: mediaId, Category: b }
    return a
  }, {})
}

interface ICompareArraysParams {
  mediaId: string
  categories: ICategory[]
  listOld: TCategoryDetailDTO[]
  list: TCategoryDetailDTO[]
}

export const compareArrays = (params: ICompareArraysParams): ISelectCategoryChange[] => {
  const { mediaId, categories, listOld, list } = params

  const result: ISelectCategoryChange[] = []
  const dCategory = mergeCategoryDetailDictionaryByName({ mediaId, categories, categoryDetails: listOld })

  // Tạo Set từ Olds và B để tăng tốc độ tìm kiếm
  const oldSet = new Set(listOld.map((x) => x.Category?.Name ?? ''))
  const newSet = new Set(list.map((x) => x.Category?.Name ?? ''))

  // Kiểm tra phần tử thêm mới
  for (const item of list) {
    const categoryDetail = dCategory[item.Category?.Name ?? '']
    if (categoryDetail && item.Category?.Name && !oldSet.has(item.Category.Name)) {
      result.push({ value: categoryDetail, status: EChangeValue.Add })
    }
  }

  // Kiểm tra phần tử bị xóa
  for (const item of listOld) {
    const categoryDetail = dCategory[item.Category?.Name ?? '']
    // console.log({ categoryDetail, name: item.Category?.Name, check: !newSet.has(item.Category?.Name ?? '') })

    if (categoryDetail && item.Category?.Name && !newSet.has(item.Category.Name)) {
      result.push({ value: categoryDetail, status: EChangeValue.Remove })
    }
  }
  return result
}
